import React from "react";

const CardBodyText = ({ children }) => {
  return <div className="card-body-text">{children}</div>;
};

export default CardBodyText;
